/* =====================================================
   GC 2026 Stats Section Counter Animation
   File: assets/gc-2026-stats-section.js
===================================================== */

(function () {
  'use strict';

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function formatCounterValue(value, decimals) {
    var fixed = Number(value).toFixed(decimals);

    return decimals > 0
      ? fixed
      : String(Math.round(value));
  }

  function animateCounter(counter) {
    if (!counter) return;

    if (
      counter.dataset.gcAnimated === 'true' ||
      counter.dataset.gcAnimated === 'running'
    ) {
      return;
    }

    var target = parseFloat(
      counter.getAttribute('data-gc-count')
    );

    var decimals = parseInt(
      counter.getAttribute('data-gc-decimals') || '0',
      10
    );

    var valueHolder = counter.querySelector(
      '.gc-commerce-count-value'
    );

    if (!valueHolder) return;

    if (isNaN(target)) {
      target = 0;
    }

    if (isNaN(decimals)) {
      decimals = 0;
    }

    var duration = 1450;
    var startTime = null;

    counter.dataset.gcAnimated = 'running';

    function step(timestamp) {
      if (startTime === null) {
        startTime = timestamp;
      }

      var progress = Math.min(
        (timestamp - startTime) / duration,
        1
      );

      var eased = easeOutCubic(progress);
      var current = target * eased;

      valueHolder.textContent = formatCounterValue(
        current,
        decimals
      );

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        valueHolder.textContent = formatCounterValue(
          target,
          decimals
        );

        counter.dataset.gcAnimated = 'true';
      }
    }

    window.requestAnimationFrame(step);
  }

  function initializeCounters(root) {
    var scope = root || document;

    var counters = scope.querySelectorAll(
      '.gc-commerce-stat-number[data-gc-count]'
    );

    counters.forEach(function (counter) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                animateCounter(entry.target);
                obs.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.3
          }
        );

        observer.observe(counter);
      } else {
        animateCounter(counter);
      }
    });
  }

  function initializeAllStats() {
    document
      .querySelectorAll('.gc-2026-stats-section')
      .forEach(function (section) {
        initializeCounters(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllStats,
      { once: true }
    );
  } else {
    initializeAllStats();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeCounters(event.target);
    }
  );
})();